<template>
    <main>
    <c-container class="my-3">
      <c-row class="my-3">
        <c-col>
          <h2>Dostępne towary - Złóż zamówienie online</h2>
        </c-col>
      </c-row>
      <c-row class="my-3">
        <c-col>
          <p class="lead font-xl">
            Poniżej przedstawiamy listę dostępnych
            towarów do zamówienia. Aby dodać towar do Twojego zamówienia,
            kliknij na przycisk "Dodaj do zamówienia" i podaj ilość.
            <strong>
              Aby przekazać do nas zamówienie, przejdź do zakładki "Koszyk",
              gdzie zostaniesz poproszony o kilka dodatkowych danych.
            </strong>
          </p>
        </c-col>
      </c-row>
      <c-row class="my-5">
        <c-col class="text-center">
          <c-button class="btn-lg btn-primary" to="/cart">Przejdź do podsumowania koszyka</c-button>
        </c-col>
      </c-row>
      <c-row class="my-3">
        <c-col>
          <products-list/>
        </c-col>
      </c-row>
    </c-container>
  </main>
</template>
<script>
import ProductsList from '@/components/ProductsList'

export default {
  name: 'ProductsPage',
  components: {ProductsList},
  mounted() {
    this.$store.dispatch('fetchProducts')
  }
}
</script>